import React, { useContext } from "react";
import context from "@/components/Joyspace/context";
interface Props {
  children: React.ReactNode;
}

export default function __default(props: Props) {
  let breadcrumbs: React.ReactNode | null = null;
  let sidebar: React.ReactElement | null = null;
  let batch: React.ReactElement | null = null;
  const { selectTableArray } = useContext(context);
  const children: React.ReactNode[] = [];
  React.Children.forEach(props.children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type.valueOf() === Breadcrumbs) {
        breadcrumbs = child;
        return;
      }
      if (child.type.valueOf() === Sidebar) {
        sidebar = child;
        return;
      }
    }
    children.push(child);
  });
  return (
    <>
      <div className="joyspace-main-container">
        {breadcrumbs}
        {children}
        <div id="joyspace-main-footer" />
      </div>
      {sidebar}
    </>
  );
}

function Sidebar(props: { children: React.ReactNode }) {
  return props.children ? <div className="joyspace-main-sidebar">{props.children}</div> : null;
}

function Breadcrumbs(props: { children?: React.ReactNode; text?: string }) {
  const children: React.ReactNode = props.children || props.text;
  if (children) {
    return <div className="joyspace-main-breadcrumbs">{children}</div>;
  }
  return null;
}

__default.Sidebar = Sidebar;
__default.Breadcrumbs = Breadcrumbs;
